/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ListPlansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListPlansQuery = { __typename?: 'Query', listPlans: Array<{ __typename?: 'PlanModel', plan_id: string, name: string }> };

export type ListPurchasedPlansQueryVariables = Types.Exact<{
  input: Types.ListPurchasedPlansInput;
}>;


export type ListPurchasedPlansQuery = { __typename?: 'Query', listPurchasedPlans: Array<{ __typename?: 'ContractPlanModel', plan_id: string, account_id: string, limit: number, name: string, user_plans: { __typename?: 'UserPlanTypeModel', active: number, invited: number, new: number, total: number } }> };

export type UpdatePurchasedPlanMutationVariables = Types.Exact<{
  input: Types.UpsertPurchasedPlansInput;
}>;


export type UpdatePurchasedPlanMutation = { __typename?: 'Mutation', updatePurchasedPlan: { __typename?: 'ContractPlanModel', plan_id: string, name: string, account_id: string, limit: number } };


export const ListPlansDocument = gql`
    query listPlans {
  listPlans {
    plan_id
    name
  }
}
    `;
export function useListPlansQuery(baseOptions?: Apollo.QueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
      }
export function useListPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
        }
// @ts-ignore
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPlansQuery, ListPlansQueryVariables>;
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPlansQuery | undefined, ListPlansQueryVariables>;
export function useListPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPlansQuery, ListPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPlansQuery, ListPlansQueryVariables>(ListPlansDocument, options);
        }
export type ListPlansQueryHookResult = ReturnType<typeof useListPlansQuery>;
export type ListPlansLazyQueryHookResult = ReturnType<typeof useListPlansLazyQuery>;
export type ListPlansSuspenseQueryHookResult = ReturnType<typeof useListPlansSuspenseQuery>;
export type ListPlansQueryResult = Apollo.QueryResult<ListPlansQuery, ListPlansQueryVariables>;
export const ListPurchasedPlansDocument = gql`
    query listPurchasedPlans($input: ListPurchasedPlansInput!) {
  listPurchasedPlans(input: $input) {
    plan_id
    account_id
    limit
    name
    user_plans {
      active
      invited
      new
      total
    }
  }
}
    `;
export function useListPurchasedPlansQuery(baseOptions: Apollo.QueryHookOptions<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables> & ({ variables: ListPurchasedPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>(ListPurchasedPlansDocument, options);
      }
export function useListPurchasedPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>(ListPurchasedPlansDocument, options);
        }
// @ts-ignore
export function useListPurchasedPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>;
export function useListPurchasedPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListPurchasedPlansQuery | undefined, ListPurchasedPlansQueryVariables>;
export function useListPurchasedPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>(ListPurchasedPlansDocument, options);
        }
export type ListPurchasedPlansQueryHookResult = ReturnType<typeof useListPurchasedPlansQuery>;
export type ListPurchasedPlansLazyQueryHookResult = ReturnType<typeof useListPurchasedPlansLazyQuery>;
export type ListPurchasedPlansSuspenseQueryHookResult = ReturnType<typeof useListPurchasedPlansSuspenseQuery>;
export type ListPurchasedPlansQueryResult = Apollo.QueryResult<ListPurchasedPlansQuery, ListPurchasedPlansQueryVariables>;
export const UpdatePurchasedPlanDocument = gql`
    mutation updatePurchasedPlan($input: UpsertPurchasedPlansInput!) {
  updatePurchasedPlan(input: $input) {
    plan_id
    name
    account_id
    limit
  }
}
    `;
export type UpdatePurchasedPlanMutationFn = Apollo.MutationFunction<UpdatePurchasedPlanMutation, UpdatePurchasedPlanMutationVariables>;
export function useUpdatePurchasedPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchasedPlanMutation, UpdatePurchasedPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchasedPlanMutation, UpdatePurchasedPlanMutationVariables>(UpdatePurchasedPlanDocument, options);
      }
export type UpdatePurchasedPlanMutationHookResult = ReturnType<typeof useUpdatePurchasedPlanMutation>;
export type UpdatePurchasedPlanMutationResult = Apollo.MutationResult<UpdatePurchasedPlanMutation>;
export type UpdatePurchasedPlanMutationOptions = Apollo.BaseMutationOptions<UpdatePurchasedPlanMutation, UpdatePurchasedPlanMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListPlans = withQueryResponseHandler(useListPlansQuery);
export const useListPurchasedPlans = withQueryResponseHandler(useListPurchasedPlansQuery);
export const useUpdatePurchasedPlan = withMutationResponseHandler(useUpdatePurchasedPlanMutation, "updatePurchasedPlan");